import $ from 'jquery';
import {useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
  FLG_SEND,
} from 'web/constant';
import {sendSatisfactionMessage} from 'web/redux/actions/CaseActions';
import {
  fetchSatisfaction,
  fetchSatisfactionList,
} from 'web/redux/actions/SatisfactionAction';
import enumList from 'web/utils/enumList';
import {
  DataTableComponent,
  batchCheckControls,
} from '../../../components/CommonComponent';
import {updateCurrentMsg} from 'web/utils/modalHelper';

export const useSatisfactionSurvey = (
  showMessage,
  onBatchHandle,
  baseComponent,
  toggleSatisfactionModal,
) => {
  const dispatch = useDispatch();
  const [surveyList, setSurveyList] = useState([]);
  const [searchCasePriority, setSearchCasePriority] = useState('0');
  const [searchFlgStatus, setSearchFlgStatus] = useState('0');
  const [searchStartDate, setSearchStartDate] = useState(
    moment().format('YYYY-MM-DD'),
  );
  const [searchEndDate, setSearchEndDate] = useState(
    moment().format('YYYY-MM-DD'),
  );
  const tableRef = useRef(null);
  const getSurveyList = (casePriority, surveyStatus, startTime, endTime) => {
    if (!tableRef.current) prepareCaseTable([]);
    tableRef.current.processing(true);

    startTime = moment(startTime).startOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 00:00:00
    endTime = moment(endTime).endOf('day').format('YYYYMMDDHHmmss') || ''; // 👉 20250417 23:59:59
    dispatch(
      fetchSatisfactionList({
        casePriority,
        surveyStatus,
        startTime,
        endTime,
      }),
    )
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode()) {
          const surveyListRes = res.payload.result;
          setSurveyList(surveyListRes);
          prepareCaseTable(surveyListRes);
          tableRef.current.processing(false);
        } else {
          showMessage(enumList.messageModalMode.error, res.payload.message);
          console.error('fetchCaseList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchCaseList error', err);
      });
  };

  const onSendSatisfactionMessageButtonClick = async (caseNumber) => {
    try {
      showMessage(
        enumList.messageModalMode.loading,
        '已排入發送佇列',
        '信件發送中',
        enumList.disabled,
      );
      const res = await dispatch(
        sendSatisfactionMessage({caseNumber}),
      ).unwrap();

      if (res.code.isSuccessCode()) {
        updateCurrentMsg(
          enumList.messageModalMode.info,
          '發送成功',
          '信件已發送',
        );
        getSurveyList(
          searchCasePriority,
          searchFlgStatus,
          searchStartDate,
          searchEndDate,
        );
      }
    } catch (error) {
      console.error('here is error', error);
      updateCurrentMsg(
        enumList.messageModalMode.error,
        error?.message ?? '發生錯誤',
      );
    }
  };

  const prepareCaseTable = (surveyList) => {
    // 定義資料內容
    const dataSet = surveyList.map((surveyItem) => {
      return [
        surveyItem.casePriority || '',
        surveyItem.caseNumber || '',
        surveyItem.caseCreateTime || '',
        surveyItem.customerName || '',
        surveyItem.description || '',
        surveyItem.flgStatus,
        surveyItem.caseNumber || '',
        surveyItem.caseId || '',
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '案件等級',
        className: 'dt-center',
        data: 0,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const casePriority =
            data === enumList.casePriority.high
              ? CASE_PRIORITY_HIGH
              : CASE_PRIORITY_NORMAL;
          const labelStyle =
            data === enumList.casePriority.high ? 'status-rush' : '';
          return ` <div class="status ${labelStyle} "> <span>${casePriority}</span> </div>`;
        },
      },
      {title: '案件編號', className: 'dt-center', data: 1},
      {
        title: '立案時間',
        className: 'dt-head-center',
        data: 2,
        render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'),
        type: 'datetime',
      },
      {title: '客戶名稱', className: 'dt-center', data: 3},
      {title: '案件內容', className: 'dt-center text-truncate', data: 4},
      {
        title: '滿意度回饋',
        className: 'dt-center',
        data: 5,
        render: (data, type, row, meta) => {
          // let enableId = 'eab-elevator-' + meta.row;
          const statusMap = new Map([
            [enumList.satisfactionFlgStatus.close, FLG_CLOSE],
            [enumList.satisfactionFlgStatus.send, FLG_SEND],
            [enumList.satisfactionFlgStatus.open, FLG_OPEN],
          ]);

          const satisfactionStatus = statusMap.get(data);
          const labelStyle =
            data === enumList.satisfactionFlgStatus.close
              ? 'status-normal'
              : 'status-danger';
          return ` <div class="status ${labelStyle} mb-2"> <span>${satisfactionStatus}</span> </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '',
        className: 'dt-center',
        data: 6,
        render: (data, type, row, meta) => {
          /** @type {HTMLButtonElement} */
          let element = document.createDocumentFragment();
          if (
            baseComponent.checkPermission(
              enumList.moduleEnums.case,
              enumList.accessModeEnums.update,
            )
          ) {
            element = document.createElement('button');
            element.type = 'button';
            element.classList.add('btn', 'btn-sm', 'btn-outline-secondary');
            element.addEventListener('click', () => {
              onSendSatisfactionMessageButtonClick(data);
            });
            element.innerHTML = '點擊寄送<i class="bi bi-send"></i>';
          }
          /** @type {HTMLDivElement} */
          const outerDiv = document.createElement('div');
          outerDiv.setAttribute('role', 'group');
          outerDiv.classList.add('btn-group');
          outerDiv.append(element);
          return outerDiv;
        },
      },
      {
        orderable: false,
        order: null,
        title: '',
        className: 'dt-center',
        data: 7,
        render: (data, type, row, meta) => {
          /** @type {HTMLButtonElement} */
          let element = document.createDocumentFragment();
          if (
            baseComponent.checkPermission(
              enumList.moduleEnums.case,
              enumList.accessModeEnums.update,
            )
          ) {
            element = document.createElement('button');
            element.type = 'button';
            element.classList.add('btn', 'btn-sm', 'btn-outline-secondary');
            element.addEventListener('click', async () => {
              try {
                await dispatch(fetchSatisfaction(data)).unwrap();
                toggleSatisfactionModal();
              } catch (error) {
                console.error(error);
              }
            });
            element.innerHTML = '評分<i class="bi bi-pencil"></i>';
          }
          /** @type {HTMLDivElement} */
          const outerDiv = document.createElement('div');
          outerDiv.setAttribute('role', 'group');
          outerDiv.classList.add('btn-group');
          outerDiv.append(element);
          return outerDiv;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__satisfactionList')) {
      $('#datatable__satisfactionList').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__satisfactionList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    setSurveyList(surveyList);
    batchCheckControls();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const searchForm = new FormData(e.target);
    const casePriority = searchForm.get('searchCasePriority');
    const caseDispatchEmployee = searchForm.get('searchDispatchEmployee');
    const startTime = searchForm.get('searchStartDate');
    const endTime = searchForm.get('searchEndDate');
    getDispatchList(casePriority, caseDispatchEmployee, startTime, endTime);
  };

  const onBatch = (alertMode = enumList.alertModalModeEnums.enable) => {
    const selectedCaseNumbers = [];
    const checkboxes = document.querySelectorAll('.item-cks-survey');
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const idx = parseInt(checkbox.id.split('-')[2]);
        selectedCaseNumbers.push(surveyList[idx].caseNumber);
      }
    });
    if (selectedCaseNumbers.length === 0) return;
    onBatchHandle(alertMode, '', selectedCaseNumbers);
  };

  return {
    surveyList,
    getSurveyList,
    handleSearch,
    onBatch,
    searchCasePriority,
    setSearchCasePriority,
    searchFlgStatus,
    setSearchFlgStatus,
    searchStartDate,
    setSearchStartDate,
    searchEndDate,
    setSearchEndDate,
  };
};
